<script>

export default
{
    name: 'blank',

    render () 
    {
        return (
            <div id='blank-view'>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#blank-view
{
    
}
</style>



// WEBPACK FOOTER //
// src/views/Blank.vue